import React from "react"
import styled from "styled-components"
import AvailabilityContent from "./AvailabilityContent"
import { StaticImage } from "gatsby-plugin-image"

export default function AvailabilityCard() {
  return (
    <Wrapper>
      <StaticImage
        className="img"
        src="../../assets/images/mar2.jpg"
        layout="fullWidth"
        alt="puelo"
        placeholder="blurred"
      />
      <AvailabilityContent />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  width: 100%;
  position: relative;
  height: 650px;

  .img {
    width: 100%;
    height: 100%;
    max-height: 760px;
  }
`
